module.exports = __webpack_public_path__ + "img/sakura_half.93efefa9.png";